import React from "react";
import "./details.css";

const DetailsTable = ({ companyData }) => {
  if (!companyData) return null;

  return (
    <div className="details-page mt-3">
      <h2>Company Details</h2>

      <div className="row mt-4">
        <div className="col-md-4">
          {companyData.companyName && (
            <p>
              <strong>Company Name:</strong> {companyData.companyName}
            </p>
          )}

          {companyData.clientName && (
            <p>
              <strong>Client Name:</strong> {companyData.clientName}
            </p>
          )}

          {companyData.email && (
            <p>
              <strong>Email:</strong> {companyData.email}
            </p>
          )}

          {companyData.mobileNumber && (
            <p>
              <strong>Mobile:</strong> {companyData.mobileNumber}
            </p>
          )}
        </div>

        <div className="col-md-4">
          {companyData.city && (
            <p>
              <strong>City:</strong> {companyData.city}
            </p>
          )}

          {companyData.gstNumber && (
            <p>
              <strong>GST Number:</strong> {companyData.gstNumber}
            </p>
          )}

          {companyData.website && (
            <p>
              <strong>Website:</strong> {companyData.website}
            </p>
          )}
          {companyData?.alternateEmails?.length > 0 && (
            <p>
              <strong>Alternate Emails:</strong>{" "}
              {companyData.alternateEmails.join(", ")}
            </p>
          )}
        </div>

        <div className="col-md-4">
          {companyData.address && (
            <p>
              <strong>Address:</strong> {companyData.address}
            </p>
          )}
        </div>
      </div>

      {/* Standards */}
      <div className="mt-4">
        <h4>Standards</h4>

        {companyData?.standards?.length > 0 ? (
          <ul>
            {companyData.standards.map((std) => (
              <li key={std._id}>{std.standardName}</li>
            ))}
          </ul>
        ) : (
          <p>No standards available</p>
        )}
      </div>
    </div>
  );
};

export default DetailsTable;
